import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { routesConfig } from './routesConfig';

function AppRouter() {
  const router = createBrowserRouter(routesConfig);
  return <RouterProvider router={router} />;
}

export default AppRouter;
